export const CART_URL =
  'https://tusprimeros1000usdconugc.shop/cart/add?id=52819999457461&quantity=1'

export const PRODUCT_NAME = 'Tus primeros USD 1.000 con contenido UGC'

export const IMAGES = {
  ebook: 'https://cdn.magicpatterns.com/uploads/kUPRjDe7FWEFYKkCqpCEik/Imagen_Ebook.jpg',
  transformation:
    'https://cdn.magicpatterns.com/uploads/roQ13czEQaixrkzGP3G5qM/WhatsApp_Image_2026-07-19_at_10.19.17_PM.jpg',
  modules:
    'https://cdn.magicpatterns.com/uploads/2wBFqXjLKXKTK7vyXixYhm/imagen_para_alado_de_los_modulos.jpg',
  preview:
    'https://cdn.magicpatterns.com/uploads/eXG9Mf1gMC5ZfHUMiSTZHn/imagen_para_el_apartado_de_leerse_y_aplicarse.jpg',
  bonus1: 'https://cdn.magicpatterns.com/uploads/6TT73EUV2gTayfVhqHiYhK/Bono_1.jpg',
  bonus2: 'https://cdn.magicpatterns.com/uploads/hL5YSj41m8Us6UspTgFPki/Bono_2.jpg',
  bonus3: 'https://cdn.magicpatterns.com/uploads/iSL3vBSUnEtV41yuyr6cxP/Bono_3.jpg',
}
